export default "__VITE_ASSET__27aac020__"